import { useCallback } from 'react';

import { useRouter } from '../../../hooks/router/useCustomRouter';
import { TopBarIcon, type TopBarIconProps } from '../../atoms';
import { ChevronLeftBoldIcon } from '../../icons';

interface BackButtonProps extends Omit<TopBarIconProps, 'icon' | 'onClick'> {
	bordered?: boolean;
	forceTheme?: 'dark' | 'light';
	onClick?: () => void;
}

export const BackButton = ({ bordered, onClick, ...props }: BackButtonProps) => {
	const { back } = useRouter();
	const onPressHandler = useCallback(() => {
		onClick ? onClick() : back();
	}, [onClick, back]);

	return <TopBarIcon bordered={bordered} icon={ChevronLeftBoldIcon} onClick={onPressHandler} {...props} />;
};
